import React from 'react'

function AddMember() {
  return (
    <div>AddMember</div>
  )
}

export default AddMember